import { render, staticRenderFns } from "./CInputText.vue?vue&type=template&id=0b516dca"
import script from "./CInputText.vue?vue&type=script&lang=js"
export * from "./CInputText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports